import PropTypes from 'prop-types'

import { ObjectEbsState } from '../../models/ebs/object-ebs-state-enum'
import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { objectEbsStateEventPropType } from './object-ebs-state-event-prop-type'
import { brakePerformancePropType } from './brake-performance-prop-type.js'

const { AXLE_LOAD, BRAKE_PERFORMANCE, EBS_EVENTS, LAST_MODIFIED, OBJECT_ID, SPEED } = ObjectEbsState

/**
 * @typedef {Object} ObjectEbsState
 *
 * @property {number} [axleLoad]                        - The axle load of the object EBS state
 * @property {BrakePerformance} [brakePerformance]      - The brake performance of the object EBS state
 * @property {Array} [ebsEvents]                        - List of the object EBS state events
 * @property {ISO8601} [lastModified]                   - When the object EBS state was last modified
 * @property {Id} objectId                              - The object id unique identifier
 * @property {number} [speed]                           - The speed of the object EBS state
 */
export const objectEbsStatePropType = PropTypes.shape({
    [AXLE_LOAD]: PropTypes.number,
    [BRAKE_PERFORMANCE]: brakePerformancePropType,
    [EBS_EVENTS]: PropTypes.arrayOf(objectEbsStateEventPropType),
    [LAST_MODIFIED]: iso8601PropType,
    [OBJECT_ID]: idPropType.isRequired,
    [SPEED]: PropTypes.number
})
